import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0bd4518e")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "indicator pi pi-external-link" })
], -1)
const _hoisted_4 = { class: "p-col-11" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = {
  key: 4,
  class: ""
}
const _hoisted_9 = { key: 5 }
const _hoisted_10 = {
  key: 0,
  class: "p-grid"
}
const _hoisted_11 = {
  key: 1,
  class: "p-col"
}
const _hoisted_12 = {
  key: 2,
  class: "p-col"
}
const _hoisted_13 = {
  key: 3,
  class: "p-col"
}
const _hoisted_14 = {
  key: 0,
  class: "indicator pi pi-arrow-down"
}
const _hoisted_15 = {
  key: 1,
  class: "indicator pi pi-arrow-up"
}
const _hoisted_16 = {
  key: 2,
  class: /*#__PURE__*/_normalizeClass([
                    'title p-col-3 p-text-right'
                ])
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" -- ")
const _hoisted_19 = { key: 6 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" -- ")
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "p-col-fixed" }
const _hoisted_25 = { class: "p-col" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "p-col-fixed" }
const _hoisted_28 = { class: "p-col" }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { class: "p-col-fixed" }
const _hoisted_31 = { class: "p-col" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" No hay Profesores ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_spam = _resolveComponent("spam")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    value: _ctx.staffTracing.data,
    responsiveLayout: "scroll"
  }, {
    empty: _withCtx(() => [
      _hoisted_32
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
        return (_openBlock(), _createBlock(_component_Column, {
          key: col.field,
          hidden: !_ctx.showCol.includes(col.header),
          field: col.field,
          header: col.header,
          style: _normalizeStyle([col.field === _ctx.ColumnFields.OnboardingStages && 'width: 400px'])
        }, {
          body: _withCtx(({ data }) => [
            (col.field === _ctx.ColumnFields.Person && _ctx.showCol.includes('Nombre'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_router_link, {
                    to: {
                name: 'activityRegister',
                query: {
                  isReinfo: true
                },
                params: {
                  teacherId: data.userId
                }
              }
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _hoisted_3,
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("span", null, _toDisplayString(data.userInfo.profile ? `${data.userInfo.profile.firstName} ${data.userInfo.profile.lastName}` : '--'), 1)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              : _createCommentVNode("", true),
            (col.field === _ctx.ColumnFields.Course)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(data.camadaInfo? data.camadaInfo.id : '--'), 1)
                ]))
              : _createCommentVNode("", true),
            (col.field === _ctx.ColumnFields.CoursePlan)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(data.levelInfo? data.levelInfo.title : '--'), 1)
                ]))
              : _createCommentVNode("", true),
            (col.field === _ctx.ColumnFields.TracingType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("span", null, _toDisplayString(data.assignationType), 1)
                ]))
              : _createCommentVNode("", true),
            (col.field === _ctx.ColumnFields.TracingActions)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_Tag, {
                    style: {"color":"black"},
                    class: "p-tag-gray-brain"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.tracingActions ? data.tracingActions : '--'), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : _createCommentVNode("", true),
            (col.field === _ctx.ColumnFields.TracingRating)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (data.rating)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (data.rating.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass([
                'p-col',
                data.rating.value >= 4.7 ? 'text-green-brain ' : 'text-red-brain'
                ])
                            }, _toDisplayString(data.rating.value.toFixed(2) ?? '--'), 3))
                          : (_openBlock(), _createElementBlock("div", _hoisted_11, " -- ")),
                        (data.rating.variation)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(data.rating.variation.toFixed(2)), 1))
                          : _createCommentVNode("", true),
                        (data.rating.variation)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              (data.rating.variation < 0)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                                : (data.rating.variation > 0)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_16))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_spam, null, {
                          default: _withCtx(() => [
                            _hoisted_18
                          ]),
                          _: 1
                        })
                      ]))
                ]))
              : _createCommentVNode("", true),
            (col.field === _ctx.ColumnFields.TracingTags)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (data.tracingTags === undefined || null || data.tracingTags.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(_component_spam, null, {
                          default: _withCtx(() => [
                            _hoisted_21
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        (data.tracingTags.positive !== undefined || null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.tracingTags.positive, (tag) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: tag,
                                  class: "p-grid"
                                }, [
                                  _createElementVNode("div", _hoisted_24, [
                                    _createVNode(_component_Tag, {
                                      style: {"color":"black"},
                                      class: _normalizeClass(['p-tag-light-green-brain'])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(tag.value), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _createElementVNode("div", _hoisted_25, [
                                    _createVNode(_component_Tag, {
                                      style: {"color":"black"},
                                      class: _normalizeClass(['p-tag-light-green-brain'])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(tag.title), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (data.tracingTags.negative !== undefined || null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.tracingTags.negative, (tag) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: tag,
                                  class: "p-grid"
                                }, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createVNode(_component_Tag, {
                                      style: {"color":"black"},
                                      class: _normalizeClass(['p-tag-red-brain'])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(tag.value), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _createElementVNode("div", _hoisted_28, [
                                    _createVNode(_component_Tag, {
                                      style: {"color":"black"},
                                      class: _normalizeClass(['p-tag-red-brain'])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(tag.title), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (data.tracingTags.neutral !== undefined || null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.tracingTags.neutral, (tag) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: tag,
                                  class: "p-grid"
                                }, [
                                  _createElementVNode("div", _hoisted_30, [
                                    _createVNode(_component_Tag, {
                                      style: {"color":"black"},
                                      class: _normalizeClass(['p-tag-yellow-brain'])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(tag.value), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _createElementVNode("div", _hoisted_31, [
                                    _createVNode(_component_Tag, {
                                      style: {"color":"black"},
                                      class: _normalizeClass(['p-tag-yellow-brain'])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(tag.title), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["hidden", "field", "header", "style"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value"]))
}